import React from 'react';
import styled from 'styled-components';

export const Section = styled.section`
display: flex;
gap: 3em;
align-items: center;
justify-content: center;
margin-left: 15em;
margin-right: 15em;
`
export const Cont = styled.div`
display: flex;
flex-direction: column;
gap: 2em;
`
export const Title = styled.h1`
font-size: 30px;
`

export const Carts = styled.div`
display: flex;
gap: 1em;
`

export const Cart = styled.div`
background-color: #202027;
height: 6em;
width: 6em;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`
export const Image = styled.img`
background-color: #202027;
`
export const Name = styled.p`
background-color: #202027;
`
export const Albums = styled.img`
width: 20em;
height: 20em;
margin-top: 5em;
`
